import { CardVariant } from "../models/CardVariant";
import { DeckState } from "../models/Deck";
import { downloadFiles } from "../utilities";

export function downloadTableTopSimulatorDeck(deck: DeckState, cardsBySerialDictionary: Record<string, CardVariant>) {
    let result = "--Generated By materiahunter.com--";
    result = `${result}\nDeck Name: ${deck.editableFields.unsaved.name}`;
    result = `${result}\nCreated by: ${deck.editableFields.unsaved.playerName}`;
    result = `${result}\n`;
    result = `${result}\n`;
    result = `${result}\nmain(${deck.totalCards}):`;
    result = `${result}\n`;

    let forwards: Record<string, number> = {};
    let backups: Record<string, number> = {};
    let summons: Record<string, number> = {};
    let monsters: Record<string, number> = {};
    let lbs: Record<string, number> = {};

    Object.entries(deck.editableFields.unsaved.totalCardsBySerial).forEach(([serial, quantity]) => {
        const match = cardsBySerialDictionary[serial];
        if (!match) {
            return;
        }

        if (match.card.isLB) {
            lbs[serial] = quantity;
        } else {
            switch (match.card.type) {
                case "Backup":
                    backups[serial] = quantity;
                    break;
                case "Forward":
                    forwards[serial] = quantity;
                    break;
                case "Monster":
                    monsters[serial] = quantity;
                    break;
                case "Summon":
                    summons[serial] = quantity;
                    break;
                default:
                    break;
            }
        }
    });

    result = generateSection(result, "Forward", forwards, cardsBySerialDictionary);
    result = generateSection(result, "Summon", summons, cardsBySerialDictionary);
    result = generateSection(result, "Backup", backups, cardsBySerialDictionary);
    result = generateSection(result, "Monster", monsters, cardsBySerialDictionary);

    result = `${result}\nlimit break(${deck.totalLimitBreak}):`;
    result = `${result}\n`;

    forwards = {};
    backups = {};
    summons = {};
    monsters = {};

    Object.entries(lbs).forEach(([serial, quantity]) => {
        const match = cardsBySerialDictionary[serial];
        if (!match) {
            return;
        }

        switch (match.card.type) {
            case "Backup":
                backups[serial] = quantity;
                break;
            case "Forward":
                forwards[serial] = quantity;
                break;
            case "Monster":
                monsters[serial] = quantity;
                break;
            case "Summon":
                summons[serial] = quantity;
                break;
            default:
                break;
        }
    });

    result = generateSection(result, "Forward", forwards, cardsBySerialDictionary);
    result = generateSection(result, "Summon", summons, cardsBySerialDictionary);
    result = generateSection(result, "Backup", backups, cardsBySerialDictionary);
    result = generateSection(result, "Monster", monsters, cardsBySerialDictionary);

    const date = new Date();
    const deckName = deck.editableFields.unsaved.name ?? `materiahunter-deck-export-${date}`;
    const filename = `${deckName}.txt`;
    downloadFiles(result, filename, ".txt");
}

function generateSection(result: string, type: string, cards: Record<string, number>, cardsBySerialDictionary: Record<string, CardVariant>) {
    let total = 0;
    Object.values(cards).forEach((quantity) => total += quantity);

    result = `${result}\n${type}(${total}):`;
    Object.entries(cards).forEach(([serial, quantity]) => {
        const match = cardsBySerialDictionary[serial];
        if (!match) {
            return;
        }

        result = `${result}\n${quantity} ${match.card.name} (${serial})`;
    });
    result = `${result}\n`;
    return result;
}